export type Variant = {
  name: CardSize
  title: string
  dimensions: string
  sku: string | null
  key: string
}

export enum Orientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square',
}

export enum CardSize {
  Standard = 'standard',
  Large = 'large',
  Giant = 'giant',
  ECard = 'ecard',
}
